import { createClient } from '@supabase/supabase-js'

const supabaseURL = 'https://ilxpksvqekjhagluhfzb.supabase.co'
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY

export const supabaseClient = createClient(supabaseURL, supabaseKey)
